import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "popupClose",
  "use": "popupClose-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" id=\"popupClose\"><title>99E0C4D3-5BC0-4138-9206-0B4444E49EA0</title><g stroke-width=\"3\" stroke=\"#8c263e\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\"><path d=\"M12 12l24 24M12 36l24-24\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/units/Icon/icons/popupClose.svg
// module id = 512
// module chunks = 1